import { z } from 'zod';
import { pricingSchema } from './credits.js';

export const packageSchema = z.object({
  id: z.number().int().positive(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  credits: z.number().int().nonnegative(),
  priceKzt: z.number().int().nonnegative(),
  priceRubKop: z.number().int().nonnegative(),
  priceUsdCents: z.number().int().nonnegative(),
  isActive: z.boolean(),
  sortOrder: z.number().int(),
  validityDays: z.number().int().positive(),
  // 'credits' grants a lot; 'turbo' turns on turbo for turboDays.
  kind: z.enum(['credits', 'turbo']),
  turboDays: z.number().int().positive().nullable(),
});

export type Package = z.infer<typeof packageSchema>;

export const packagePublicSchema = packageSchema.pick({
  id: true,
  code: true,
  name: true,
  description: true,
  credits: true,
  priceKzt: true,
  priceRubKop: true,
  priceUsdCents: true,
  sortOrder: true,
  validityDays: true,
  kind: true,
  turboDays: true,
});

export type PackagePublic = z.infer<typeof packagePublicSchema>;

export const packagesListResponseSchema = z.object({
  packages: z.array(packagePublicSchema),
  // Prices in credits from the settings table.
  pricing: pricingSchema,
});

export type PackagesListResponse = z.infer<typeof packagesListResponseSchema>;
